import { render } from "./depositBonus.vue?vue&type=template&id=c0e33784&scoped=true"
import script from "./depositBonus.vue?vue&type=script&lang=js"
export * from "./depositBonus.vue?vue&type=script&lang=js"

import "./depositBonus.vue?vue&type=style&index=0&id=c0e33784&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e33784"]])

export default __exports__